module.exports = __webpack_public_path__ + "static/step3-element@2x-51b570d36251a2df794362a26f8f617a.png";